import React, { useContext } from 'react'
import Box from '../../box'
import TextField, { SelectOption } from '../../textfield'
import Container from '../../container'
import { DAY_OF_WEEK_ARRAY, TIMEZONE_LABEL } from '../../../types'
import AvailabilityStepContext, { AvailabilityExceptionItem, TimeRange } from './availability_step_context'
import { DayAvailabilitySelector } from './day_availability_selector'
import AvailabilityException from './availability_exception'
import Typography from '../../typography'

export interface SectionProps {
  title: string
  children: React.ReactNode
}

const Section: React.FC<SectionProps> = ({ title, children }) => {
  return (
    <Box mb={3}>
      <Typography textAlign={'right'} variant='h4' gutterBottom>{title}</Typography>
      {children}
    </Box>
  )
}

const AvailabilityStep: React.FC = () => {
  const {
    data: formData,
    setStepData: setStepFormData
  } = useContext(AvailabilityStepContext)
  const { timezone, availability, exceptions } = formData

  const onSetAvailability = (day: string, timeRanges: TimeRange[]): void => {
    let newDayAvailability: TimeRange[] = []
    if (timeRanges.length > 0) {
      newDayAvailability = timeRanges
    } else {
      newDayAvailability = []
    }
    const newAvailability = {
      ...availability,
      [day]: newDayAvailability
    }
    setStepFormData({
      ...formData as any,
      availability: newAvailability
    })
  }

  const onChangeTimezone = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target
    setStepFormData({
      ...formData as any,
      timezone: value
    })
  }

  const onChangeExceptions = (newExceptions: AvailabilityExceptionItem[]): void => {
    setStepFormData({
      ...formData as any,
      exceptions: newExceptions
    })
  }

  return (
    <Container sx={{ mb: 2 }}>
      <Section title='Standard Availabilities'>
        <TextField
        select
        value={timezone}
        onChange={onChangeTimezone}
        label='Timezone'
        fullWidth
        variant='outlined'
      >
          {Object.entries(TIMEZONE_LABEL).map(([timezone, label]) => (
            <SelectOption key={timezone} value={timezone}>{label}</SelectOption>
          ))}
        </TextField>
        <Box ml={2} mr={2} mt={4}>
          {DAY_OF_WEEK_ARRAY.map((day) => {
            return (
              <DayAvailabilitySelector
                key={day}
                day={day}
                onSetTimeRanges={(timeRange) => { onSetAvailability(day, timeRange); }}
                timeranges={availability[day]}
              />
            )
          })}
        </Box>
      </Section>
      <Section title='Exceptions'>
        <Box>
          <AvailabilityException onChangeExceptions={onChangeExceptions} exceptions={exceptions} />
        </Box>
      </Section>
    </Container>
  )
}

export default AvailabilityStep
